import React from 'react';
import { TruncateIcon } from '../../assets';
import TextTruncate from 'react-text-truncate';

export const TruncateText = ({ value, numOflines }: any): React.JSX.Element => {
    return (
        <TextTruncate
            line={numOflines}
            element='span'
            truncateText=''
            text={value}
            textTruncateChild={
                <img
                    src={TruncateIcon}
                    alt='truncate-icon'
                    style={{
                        position: 'relative',
                        top: '4px',
                    }}
                />
            }
        />
    );
};
